// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"488":"07057b3d","541":"b889f14f","846":"9b50f8a1"}[chunkId] + ".chunk.js");